/*
 * AJAX all forms
 */

window.submitForm = function submitForm(form) {
    'use strict';

    $(document).on('submit', form, function (e) {
        var form_cache = $(this),
            action = form_cache.attr('action'),
            submit_button = form_cache.find('[type="submit"]');

        var formData = new FormData(form_cache[0]);
        formData.append('ajax', 'true');

        e.preventDefault();

        // stop button from being clickable
        form_cache.addClass('submitting');
        submit_button.attr('disabled', 'disabled');

        // remove any existing instances of .successMessage - prevents multiple success messages
        $('.globalSuccessWrap').remove();

        $.ajax({
            type: 'post',
            url: action,
            data: formData,
            processData: false,
            contentType: false,
            context: form_cache,
            success: function (response) {
                if (typeof response === "string") {
                    response = $.parseJSON(response);
                }
                // cache form within success
                form_cache = $(this);

                submitFormSuccess(response, form_cache, submit_button);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // remove disabled from button if errors on page
                submit_button.removeAttr('disabled');
            }
        });

    });
};

window.submitFormSuccess = function submitFormSuccess(response, form_cache, submit_button) {
    var offset;

    // remove traces of errors so form can be updated on a subsequent submit
    form_cache.find('.inputWrap').removeClass('formError');
    form_cache.find('.formError').remove();
    form_cache.find('.globalError').remove();
    form_cache.prev('.globalSuccess').remove();

    // Attempt to refresh the reCAPTCHA token.
    if ($("#recaptcha").length) {
        grecaptcha.ready(function() {
            grecaptcha.execute('6LfuOcggAAAAAOyEESkuDy8IIXKVbLhwJxg0XAa9', {action: 'instance'}).then(function(token) {
                    $("#recaptcha").val(token);
                }
            );
        });
    }

    // if errors add these to the dom
    if (response && response.errors !== null && !$.isArray(response.errors)) {

        if ($.type(response.errors) === 'object' && !$.isEmptyObject(response.errors)) {
            // add errors to relevant fields
            $.each(response.errors, function (name, message) {
                // cache fields with errors
                var error_field = form_cache.find('input[name="' + name + '"], textarea[name="' + name + '"], select[name="' + name + '"]'),
                    error_field_last = error_field.last(),
                    error_field_row = error_field.parents('.row');

                // check if error corresponds to an input field
                if (error_field.length > 0) {
                    error_field.parent('.inputWrap').append('<div class="formError">' + message + '</div>');
                } else {

                    // check if ther is an error ul already in the dom - if not add one
                    if (!$('.globalErrorWrap').length > 0) {
                        form_cache.prepend('<ul class="globalErrorWrap"></ul>');
                    }

                    form_cache.find('.globalErrorWrap').prepend('<li class="globalError">' + message + '</li>');
                }
            });

            // remove disabled from button if errors on page
            submit_button.removeAttr('disabled');

            if ($('.overlayBoxOuter').length > 0) {
                $(window).trigger('resize.overlay');
            } else {
                // scroll to first error if the form is not in overlay
                offset = form_cache.find('.globalErrorWrap, .formError').eq(0).offset();
                // $('html, body').stop(true, true).delay(200).animate({
                //     scrollTop: offset.top - 100
                // }, 1000);
            }
        }
        // if success then move on
    } else {

        if (response && response.success !== null && !$.isArray(response.success)) {

            if (response.success.redirect) {
                $(location).attr('href', response.success.redirect);
            } else {

                // add a success message div then put all the content in this
                form_cache.before('<div class="globalSuccessWrap" />');

                // prepend title if exists
                if (response.success.title) {
                    $('.globalSuccessWrap').append(response.success.title);
                }
                $('.globalSuccessWrap').append('<div class="globalSuccess">' + response.success.message + '</div>');

                if ($('.removeAfterSubmit').length) {
                    $('.removeAfterSubmit').remove();
                }

                if (response.success.hide_form) {
                    form_cache.hide();
                }

                // scroll to success message if the form is not in overlay
                if ($('.overlayBoxOuter').length < 1) {
                    offset = $('.globalSuccessWrap').offset();
                    $('html, body').stop(true, true).delay(200).animate({
                        scrollTop: offset.top - 100
                    }, 1000);
                }
            }

            // remove disabled from button if errors on page
            form_cache.find('[type="submit"]').removeAttr('disabled');

            if ($('.overlayBoxOuter').length > 0) {
                $(window).trigger('resize.overlay');
            }
        }
    }
};